import React, { useState } from 'react'
import styles from './NewsCard.module.css'
import ActionPanel from './ActionPanel'

const NewsCard = ({ article }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    const formattedDate = article.publishedAt
        ? new Date(article.publishedAt).toLocaleDateString('en-GB', {
            day: 'numeric', month: 'short', year: 'numeric'
        })
        : null

    return (
        <div className={`${styles.card} ${isExpanded ? styles.expanded : ''}`}>
            {/* Header — always visible */}
            <div className={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
                <div className={styles.headerLeft}>
                    <div className={styles.iconContainer}>📰</div>
                    <div className={styles.headerText}>
                        <h3 className={styles.title}>{article.title}</h3>
                        <div className={styles.meta}>
                            {article.source && <span className={styles.source}>{article.source}</span>}
                            {article.source && formattedDate && <span className={styles.dot}>•</span>}
                            {formattedDate && <span className={styles.time}>📅 {formattedDate}</span>}
                        </div>
                    </div>
                </div>
                <div className={styles.headerRight}>
                    {article.match > 0 && (
                        <div className={styles.matchBadge}>
                            <span className={styles.matchPercent}>{article.match}%</span>
                            <span className={styles.matchLabel}>match</span>
                        </div>
                    )}
                    <button className={styles.expandButton}>
                        {isExpanded ? '▲' : '▼'}
                    </button>
                </div>
            </div>

            {/* Expanded content */}
            {isExpanded && (
                <div className={styles.expandedContent}>
                    {article.whyMatch && article.whyMatch.length > 0 && (
                        <div className={styles.whyMatch}>
                            <h4 className={styles.sectionHeading}>WHY IS IT A STRONG MATCH?</h4>
                            <ul className={styles.matchList}>
                                {article.whyMatch.map((reason, index) => (
                                    <li key={index} className={styles.matchItem}>
                                        <span className={styles.checkIcon}>✓</span>
                                        {reason}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {article.actions && article.actions.length > 0 && (
                        <ActionPanel actions={article.actions} />
                    )}

                    {article.url && (
                        <a
                            href={article.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.readMoreLink}
                            onClick={e => e.stopPropagation()}
                        >
                            Read Article →
                        </a>
                    )}
                </div>
            )}
        </div>
    )
}

export default NewsCard
